<template>
  <section class="contents">
    <mechanic-notes />

    <article v-if="hasProductData" :id="localComponentId" qaid="bike-overview" class="mb-6">
      <h2 class="sr-only">{{ $t('product.details.nav.label.overview') }}</h2>
      <p
        v-if="hasPositioningStatement"
        class="text-center text-lg mx-auto px-2 max-w-md lg:max-w-lg mt-3 mb-4 md:mt-6"
        :class="positionStatementClasses"
      >
        {{ product.copyPositioningStatement }}
      </p>

      <bike-overview-video
        v-if="product.localizedVideoOverview"
        :url="product.localizedVideoOverview.url"
        :asset-id="product.localizedVideoOverview.stillAssetId"
        :heading="product.localizedVideoOverview.overviewVideoHeading"
        :caption="product.localizedVideoOverview.caption"
      />
      <div v-else-if="product.assetIdOverview" class="bike-overview-image">
        <image-component
          :alt-text="$t(`altText.${product.assetIdOverview.replaceAll('_', '-')}`)"
          :asset-id="product.assetIdOverview"
          img-format="pjpg"
          aspect-ratio="16x9"
          transformation="fill"
          sizes="auto"
          css-class="w-full h-full"
          :is-data-object-fit="true"
        />
      </div>
    </article>
  </section>
</template>

<script>
import ImageComponent from '@/components/ImageComponent';
import BikeOverviewVideo from '@/components/containers/pdp/overview/bike/BikeOverviewVideo';
import MechanicNotes from '@/components/containers/pdp/overview/MechanicNotes';
import {mapState} from 'vuex';

export default {
  components: {ImageComponent, BikeOverviewVideo, MechanicNotes},
  props: {
    componentId: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      localComponentId: this.componentId || this.$attrs?.['component-data'].uid,
    };
  },
  computed: {
    ...mapState('productDetails', ['product']),
    ...mapState('backend', ['isElectraBrand', 'b2b']),

    hasProductData() {
      return !!this.product?.code;
    },
    hasPositioningStatement() {
      return !this.isElectraBrand && this.product?.copyPositioningStatement && !this.b2b;
    },
    positionStatementClasses() {
      return {
        'md:mb-6': this.product?.localizedVideoOverview,
        'md:mb-8': !this.product?.localizedVideoOverview,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.bike-overview-image :deep(picture) {
  @media (screen(xl)) {
    max-height: calc(85vh - var(--header-height));
    min-width: 100%;
  }
}
</style>
